/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import Editable from 'loracoms/Editable';
import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  dashId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

class EditName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      errors: ErrorSet.createEmpty(),
      name: props.name,
      editNameData: { name: props.name },
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentWillReceiveProps(nextProps) {
    const { name } = nextProps;
    if (name !== this.props.name) {
      this.setState({ name, editNameData: { name } });
    }
  }

  handleChangeName(data) {
    const { name } = data;
    const { errors } = this.state;
    if (_.trim(name).length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
    this.setState({ editNameData: data });
  }

  handleCancelEdit() {
    const { name, errors } = this.state;
    this.setState({
      name,
      edit: false,
      editNameData: { name },
      errors: errors.remove('name'),
    });
  }

  handleSubmitName() {
    const { editNameData: { name }, errors } = this.state;
    const { dashId } = this.props;
    if (errors.has('name')) {
      return;
    }
    callAPI({ endpoint: `/lora/dashboards/${dashId}`, method: 'PUT', body: { name } })
      .then(() => {
        this.setState({ name, editNameData: { name } });
      })
      .catch(() => {});
    this.setState({ edit: false });
  }

  render() {
    const {
      edit,
      editNameData,
      name,
      errors,
    } = this.state;
    return (
      <div>
        <Editable
          id="name"
          edit={edit}
          data={editNameData}
          value={name}
          formatter={() => <span>{name}</span>}
          onChange={d => this.handleChangeName(d)}
          error={this.intlMsg.errorMsg(errors.get('name'))}
          errorPlacement={'top'}
        />
        <ShowIf if={!edit}>
          <Link
            className={`halflings halflings-pencil ${styles.edit}`}
            onClick={() => this.setState({ edit: true })}
          />
        </ShowIf>
        <ShowIf if={edit}>
            <span className={styles.icons}>
              <Link
                onClick={() => this.handleSubmitName()}
              >
                <span className={`halflings halflings-ok ${styles.ok}`} />
              </Link>
              <Link
                onClick={() => this.handleCancelEdit()}
              >
                <span className={`halflings halflings-remove ${styles.remove}`} />
              </Link>
            </span>
        </ShowIf>
      </div>
    );
  }
}

EditName.propTypes = propTypes;

export default injectIntl(EditName);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/EditName/index.jsx